import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { environment } from 'src/environments/environment.development';

@Component({
  selector: 'app-order-track',
  templateUrl: './order-track.component.html',
  styleUrls: ['./order-track.component.scss'],
})
export class OrderTrackComponent implements OnInit {
  trackingSteps: any[] = []; // Array of steps
  loading = false;
  error = '';
  trackingData: any; // <-- Add this
  data: string;
  imageUrl = environment.ImageBaseUrl;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: ApiServiceService
  ) {}

  ngOnInit(): void {
    const waybill = this.route.snapshot.queryParamMap.get('waybill');
    const data = this.route.snapshot.queryParamMap.get('products');
    this.data = JSON.parse(data);
    console.log('waybill-->', this.data);

    if (waybill) {
      this.fetchTrackingById(waybill);
    } else {
      this.error = 'No tracking ID found in URL.';
    }
  }

  fetchTrackingById(waybill: string) {
    this.loading = true;
    this.error = '';

    this.api.getTrackingInfo(waybill).subscribe({
      next: (res) => {
        this.loading = false;

        if (res && res.trackingData?.length > 0) {
          this.trackingData = res.trackingData[0]; // full shipment data
          const shipment = this.trackingData.Shipment;

          if (shipment?.Scans?.length > 0) {
            this.trackingSteps = this.formatTrackingData(shipment.Scans);
          } else {
            this.error = 'No scan history available.';
          }
        } else {
          this.error = res.message || 'No tracking info found.';
        }
      },
      error: (err) => {
        this.loading = false;
        this.error = err?.error?.message || 'Failed to load tracking info.';
      },
    });
  }

  // private formatTrackingData(scanDetails: any[]): any[] {
  //   if (!scanDetails || scanDetails.length === 0) return [];

  //   // ✅ Last scan detail
  //   const lastScanDetail = scanDetails[scanDetails.length - 1]?.ScanDetail || {};
  //   const currentStatus = (lastScanDetail.Scan || '').toLowerCase();

  //   // Define pipeline
  //   const stages = [
  //     { key: "Manifested", label: "Ready to Ship" },
  //     { key: "in transit", label: "In Transit" },
  //     { key: "out for delivery", label: "Out for Delivery" },
  //     { key: "delivered", label: "Delivered" }
  //   ];

  //   // Find matching stage index
  //   let lastMatchedIndex = -1;
  //   stages.forEach((stage, index) => {
  //     if (currentStatus.includes(stage.key)) {
  //       lastMatchedIndex = index;
  //     }
  //   });

  //   // Build steps
  //   return stages.map((stage, index) => {
  //     const step: any = {
  //       label: stage.label,
  //       status: "pending",
  //       date: null,
  //       location: null
  //     };

  //     if (index < lastMatchedIndex) {
  //       // ✅ Completed: find its own matching scan
  //       const scanMatch = scanDetails.find(s =>
  //         (s.ScanDetail?.Scan || '').toLowerCase().includes(stage.key)
  //       );
  //       step.status = "completed";
  //       step.date = scanMatch?.ScanDetail?.ScanDateTime || null;
  //       step.location = scanMatch?.ScanDetail?.ScannedLocation || null;
  //     }

  //     if (index === lastMatchedIndex) {
  //       // ✅ Current: always show last scan detail
  //       step.status = "current";
  //       step.date = lastScanDetail?.ScanDateTime || null;
  //       step.location = lastScanDetail?.ScannedLocation || null;
  //     }

  //     return step;
  //   });
  // }

  // private formatTrackingData(statusObj: any): any[] {
  //   const currentStatus = (statusObj.Status || '').toLowerCase();
  //   const statusDate = statusObj.StatusDateTime || null;
  //   const statusLocation = statusObj.StatusLocation || null;

  //   // Define pipeline
  //   const stages = [
  //     { key: "readytoship", label: "Ready to Ship" },
  //     { key: "in transit", label: "In Transit" },
  //     { key: "out for delivery", label: "Out for Delivery" },
  //     { key: "delivered", label: "Delivered" }
  //   ];

  //   // Find matching stage index
  //   let lastMatchedIndex = -1;
  //   stages.forEach((stage, index) => {
  //     if (currentStatus.includes(stage.key)) {
  //       lastMatchedIndex = index;
  //     }
  //   });

  //   // Build steps with date & location
  //   return stages.map((stage, index) => {
  //     const step: any = {
  //       label: stage.label,
  //       date: statusDate, // <-- add date
  //       location: statusLocation, // <-- add location
  //       status: "pending"
  //     };

  //     if (index < lastMatchedIndex) {
  //       step.status = "completed";
  //     }
  //     if (index === lastMatchedIndex) {
  //       step.status = "current";
  //     }
  //     return step;
  //   });
  // }

  private formatTrackingData(scanDetails: any[]): any[] {
    if (!scanDetails || scanDetails.length === 0) return [];

    // ✅ Last scan detail
    const lastScanDetail =
      scanDetails[scanDetails.length - 1]?.ScanDetail || {};
    const currentStatus = (lastScanDetail.Scan || '').toLowerCase();

    // Define pipeline with mapping keywords
    const stages = [
      {
        key: 'readytoship',
        label: 'Ready to Ship',
        matches: ['manifested', 'ready to ship'],
      },
      {
        key: 'in transit',
        label: 'In Transit',
        matches: ['in transit', 'picked', 'received at facility'],
      },
      {
        key: 'out for delivery',
        label: 'Out for Delivery',
        matches: ['out for delivery', 'dispatched'],
      },
      { key: 'delivered', label: 'Delivered', matches: ['delivered'] },
    ];

    // Find last matched stage index
    let lastMatchedIndex = -1;
    stages.forEach((stage, index) => {
      if (stage.matches.some((m) => currentStatus.includes(m))) {
        lastMatchedIndex = index;
      }
    });

    // Build steps
    return stages.map((stage, index) => {
      const step: any = {
        label: stage.label,
        status: 'pending',
        date: null,
        location: null,
      };

      if (index < lastMatchedIndex) {
        // ✅ Completed: find scan that matches this stage’s keywords
        const scanMatch = scanDetails.find((s) =>
          stage.matches.some((m) =>
            (s.ScanDetail?.Scan || '').toLowerCase().includes(m)
          )
        );
        step.status = 'completed';
        step.date = scanMatch?.ScanDetail?.ScanDateTime || null;
        step.location = scanMatch?.ScanDetail?.ScannedLocation || null;
      }

      if (index === lastMatchedIndex) {
        // ✅ Current: always use last scan detail
        step.status = 'current';
        step.date = lastScanDetail?.ScanDateTime || null;
        step.location = lastScanDetail?.ScannedLocation || null;
      }

      return step;
    });
  }
}
